<template>
  <div
    id="app"
    :class="{'sidebar-margin': auth.user}"
  >
    <!-- Show different headers for different roles -->
    <!-- having multiple components makes code a lot cleaner -->
    <!-- than having one huge component full of "if" statements -->
    <RecruiterHeader v-if="(auth || {}).recruiter && $route.name !== 'Login'" />
    <BusinessHeader v-if="(auth || {}).business && $route.name !== 'Login'" />
    <AgencyHeader v-if="(auth || {}).agency && $route.name !== 'Login'" />
    <Sidebar v-if="auth.user" />
    <router-view />
  </div>
</template>

<script>
import RecruiterHeader from '@/modules/recruiter/components/Header'
import BusinessHeader from '@/modules/business/components/Header'
import AgencyHeader from '@/modules/agency/components/Header'
import Sidebar from '@/components/Sidebar'
import { useAuthStore } from './stores/auth'

export default {
  name: 'App',
  components: {
    RecruiterHeader,
    BusinessHeader,
    AgencyHeader,
    Sidebar,
  },
  data () {
    return {
      auth: useAuthStore(),
    }
  },
  mounted () {
    // Update user own data at first load and then keep updating it
    this.updateSelf()
    setInterval(() => {
      this.updateSelf()
    }, 60_000)
  },
  methods: {
    updateSelf () {
      if (this.auth.user) {
        this.auth.self()
      }
    },
  },
}
</script>

<style lang="scss">
.sidebar-margin {
  margin-left: 256px;
}
</style>
